import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3524d834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-common-field" }

import { PaperClipOutlined } from '@ant-design/icons-vue';
import { OioButton } from '@kunlun/vue-ui-antd';
import { computed } from 'vue';

interface IProps {
  value: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyDetailFileFieldWidget',
  props: {
    value: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { value: string[] }



const realValue = computed(() => props.value.map((i) => i.split('/').pop()));

const handleClick = (index) => {
  window.open(props.value[index]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(realValue), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "file-item",
        key: index
      }, [
        _createVNode(_unref(PaperClipOutlined), { style: {"font-size":"14px"} }),
        _createVNode(_unref(OioButton), {
          style: {"margin-left":"5px"},
          type: "link",
          onClick: ($event: any) => (handleClick(index))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})